import { Input } from '@/src/common/components/Input/Input'
import { Mail } from '@/src/assets/icons/Mail'
import type { ComponentProps } from 'react'

export interface InputEmailInterface extends ComponentProps<typeof Input> {
  inputValue?: string
  onChangeValue?: (value: string) => void
}

export const InputEmail = ({ inputValue, onChangeValue, ...inputProps }: InputEmailInterface) => (
  <Input
    segmentAction="User Inputs Email"
    keyboardType="email-address"
    autoCorrect={false}
    autoCapitalize="none"
    autoComplete="email"
    inputContainerStyle={{ paddingStart: 12 }}
    leftIcon={<Mail />}
    value={inputValue}
    onChangeText={onChangeValue}
    {...inputProps}
  />
)
